import CommodityName from '../commodities/CommodityName';

export const StateCommodityHeader = () => <span className="settings-lookup__commodity-name">
    <span className="settings-lookup__commodity-icon-slot" aria-hidden="true" /><span>State</span>
</span>;
const StateCommodityName = ({ record }) => <span title={record.commodity?.name || record.commodityName}>
    <CommodityName commodity={{ ...record.commodity, name: record.stateName,
        commodityIcon: record.commodity?.commodityIcon || record.commodity?.name || record.commodityName }} />
</span>;
export default StateCommodityName;
